import axios from "axios";

import { axiosInstance } from "./apiInstance";
import * as urls from "./urls.json";

/**
 * Get signed URL for S3 file upload
 *
 * @param fileName - S3 key (path + sanitized name)
 * @param fileType - File extension (e.g. "pdf", "jpg")
 * @param urlPath - Upload path prefix (e.g. "uploads/files/")
 * @returns Axios promise with { url, fields }
 */
export const getSignedUrl = (
	fileName: string,
	fileType: string,
	urlPath: string = "uploads/files/"
) =>
	axiosInstance.post(
		urls.commonFileUploadURL,
		JSON.stringify({
			key: `${urlPath}${fileName}`,
			file_type: fileType,
		}),
		{ headers: { "Content-Type": "application/json" } }
	);

/**
 * Upload file to S3 using presigned URL
 *
 * @param file - File to upload
 * @param s3Path - Presigned S3 URL
 * @param fields - Form fields from getSignedUrl
 * @returns Axios promise - resolves on success
 */
export const uploadToS3 = (
	file: File,
	s3Path: string,
	fields: Record<string, string>
) => {
	const formData = new FormData();
	Object.keys(fields).forEach((key) => {
		formData.append(key, fields[key]);
	});
	formData.append("file", file);
	return axios.post(s3Path, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
};
